import { DialCodesApiService } from '../../common/services/dial-codes.api.service';
import REQUEST_STATUS from '../../common/enums/requestStatus';

export default {
  namespaced: true,
  state: {
    status: REQUEST_STATUS.LOADING,
    items: [],
    total: 0,
  },
  getters: {
    getAllDialCodes: state => state.items,
    getAllDialCodesForSelect: state =>
      state.items.map(dialCode => ({ text: dialCode.dialCode, value: dialCode.dialCode })),
    getTotal: state => state.total,
    getStatus: state => state.status,
    getDialCode: state => id => state.items.find(item => item.id === id),
  },
  mutations: {
    SET_ITEMS(state, data) {
      state.items = data;
    },
    SET_TOTAL(state, data) {
      state.total = data;
    },
    FETCH_REQUEST(state) {
      state.status = REQUEST_STATUS.LOADING;
    },
    FETCH_SUCCESS(state) {
      state.status = REQUEST_STATUS.SUCCESS;
    },
    FETCH_FAIL(state) {
      state.status = REQUEST_STATUS.FAIL;
    },
  },
  actions: {
    fetchAllDialCodes({ commit, dispatch }) {
      commit('FETCH_REQUEST');

      return DialCodesApiService.getAll()
        .then(response => {
          commit('SET_ITEMS', response.getItems());
          commit('SET_TOTAL', response.getItems().length);
          commit('FETCH_SUCCESS');
        })
        .catch(response => {
          dispatch('handleError', response);
        });
    },

    handleError({ commit }, response) {
      commit('FETCH_FAIL');
      const message = response.getFirstValidationErrorMessage() || response.getMessage();
      this.$app.$alertError(message);
    },
  },
};
